import React, { Component } from 'react'
import { connect } from 'react-redux'
import lottie from 'lottie-web'
import { injectIntl, FormattedMessage } from 'react-intl'


class SampleLoadingAnimation extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    lottie.loadAnimation({
      container: this.ref,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `/animations/sample-loader.json`,
    })
  }
  render() {
    const { intl } = this.props
    return (
      <div
        className={classNames('as-samples-loader-wrapper')}>
        <div className="sample-loading-error">
          <div 
            className="as-api-error-img"
            ref={(ref) => {
              this.ref = ref
            }}
          >
          </div>
          <div className="text-load">
            <FormattedMessage
              id="aspire.sampleLoadingAnimation.loadingSampleSuggestions"
              defaultMessage="Loading sample suggestions"
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, {
})(injectIntl(SampleLoadingAnimation))
